import React, { useContext } from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import Fab from "@mui/material/Fab";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { Page, Document } from "@react-pdf/renderer";
import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";

// Custom.
import { DownloadButtonProps } from "../../global";
import { getFileName } from "services/Utils";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import { VoAppContext } from "services/GlobalState";
import clsx from "clsx";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      transition: theme.transitions.create(["right"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),

      "&$openHelp": {
        transition: theme.transitions.create(["right"], {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen,
        }),
        [theme.breakpoints.up("lg")]: {
          right: theme.spacing(72),
        },
      },
    },
    openHelp: {},
  })
);
const DownloadButton: React.FC<DownloadButtonProps> = (props) => {
  const { document, loading, data, formState } = props;
  const { state } = useContext<any>(VoAppContext);
  const classes = useStyles();

  // Methods.

  const isDownloadable = () => {
    if (!formState) {
      return !loading && data;
    }
    return !loading && data && formState?.isValid;
  };

  return (
    <PDFDownloadLink
      className={clsx("vo-global__actions-floating-button", classes.root, {
        [classes.openHelp]: state.openHelp,
      })}
      document={
        isDownloadable() ? (
          document
        ) : (
          <>
            {/*
 // @ts-ignore */}
            <Document>
              <Page></Page>
            </Document>
          </>
        )
      }
      fileName={`${getFileName([
        data && data.firstname,
        data && data.lastname,
      ])}.pdf`}
    >
      <Fab
        color="secondary"
        aria-label="download"
        disabled={!isDownloadable()}
        title={I18n.get.misc.download}
      >
        <CloudDownloadIcon />
      </Fab>
    </PDFDownloadLink>
  );
};

export default DownloadButton;
